import * as Sentry from "@sentry/react";
import React from "react";
import NiceModal from "@ebay/nice-modal-react";
import ace from "ace-builds/src-noconflict/ace";
import "ace-builds/src-noconflict/mode-json";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./global/context/AuthenticationContext";
import "./index.css";
import reportWebVitals from "./reportWebVitals";


if (process.env.NODE_ENV != "development") {
  console.info("Start PLATFORM");
  Sentry.init({
    dsn: "https://b593bd3f8b10961f6beabec8e72fdad1@o4507538423283712.ingest.us.sentry.io/4507538424791040",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/quantri\.truonghai\.online/,
    ],
    // Session Replay
    replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}


ace.config.setModuleUrl(
  "ace/mode/json_worker",
  "https://cdnjs.cloudflare.com/ajax/libs/ace/1.4.12/worker-json.js",
);

const AppWrapper = () => (
  <BrowserRouter>
    <AuthProvider>
      <NiceModal.Provider>
        <App />
      </NiceModal.Provider>
    </AuthProvider>
  </BrowserRouter>
);

const root = ReactDOM.createRoot(document.getElementById("root"), {
  // Callback called when an error is thrown and not caught by an Error Boundary.
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn("Uncaught error", error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an Error Boundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
